import { formatPrice } from '@jbhi-fi/lanyard-ui/global/utils';

export type DeliveryTag = 'FreeDelivery' | 'PlusDelivery' | 'DeliveryFrom' | undefined;

export const getDeliveryTag = (deliveryTag: DeliveryTag, freightPrice: number | undefined) => {
  if (!deliveryTag) return;
  if (deliveryTag === 'FreeDelivery') return 'Free Delivery';
  if (deliveryTag === 'PlusDelivery') return '+ Delivery';
  if (deliveryTag === 'DeliveryFrom' && freightPrice) return `+ Delivery from $${formatPrice(freightPrice)}`;
};
